import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { TopicFeedback } from '../topic-feedback-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<TopicFeedback, unknown>[] = [
		buildColumn(util, 'Id', row => row.accSessionTopicSurveyResponseId, { header: 'accSessionTopicSurveyResponseId' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'accName', width: 30 }),
		buildColumn(util, 'Id', row => row.eventId, { header: 'eventId' }),
		buildColumn(util, 'Id', row => row.entrepreneurPersonId, { header: 'entrepreneurPersonId' }),
		buildColumn(util, 'FullName', row => row.entrepreneurName, { header: 'Entrepreneur', width: 60 }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.eventStartUTC), { header: 'Session Date', width: 60 }),
		buildColumn(util, 'Id', row => row.topicId, { header: 'topicId' }),
		buildColumn(util, 'Text', row => row.topicName, { header: 'Topic', group: 'asc', hidden: true, width: 60 }),
		buildColumn(util, 'Number', row => row.relevanceRating, { header: 'Relevance Rating', headerTooltip: 'Relevance: "This topic is important for my business. (0..10)"', hidden: true }),
		buildColumn(util, 'Number', row => row.needRating, { header: 'Need Rating', headerTooltip: 'Need: "I will use this topic knowledge within the next three months. (0..10)"', hidden: true }),
		buildColumn(util, 'Number', row => row.understandingRating, { header: 'Understanding Rating', headerTooltip: 'Understanding: "I have a better understanding of this topic and can more confidently apply it. (0..10)"', hidden: true }),
		buildColumn(util, 'Number', row => row.durationRating, { header: 'Duration Rating', headerTooltip: 'Duration: "There was adequate time dedicated to this topic. (0..10)"', hidden: true }),
		buildColumn(util, 'Text', row => row.feedback, { header: 'Feedback', filter: { operator: FilterOperator.IsNotNull } }),
	];


	return columns;

}